import { TrackData, Tracker, TrackerConfig } from '@avia/tracker'
import { usePathname, useRouter } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { useTrackerConfig } from '../src/components'
import { TrackPageSection, TrackPageType } from '../src/constant'

const baseUrl = process.env.NEXT_PUBLIC_TRACKER_BASE_URL || ''

export const useTracker = () => {
  const pathname = usePathname()
  const router = useRouter()

  const mounted = useRef(false)

  if (mounted.current) {
    if (tracker.pathname !== pathname) {
      tracker.routeChange(pathname)
    }
  }

  useEffect(() => {
    const tracker = new Tracker()
    globalThis.tracker = tracker
    const search = new URLSearchParams(window.location.search)
    let promotion: TrackData['promotion']

    if (search.size) {
      const og = search.get('og')
      const rec = search.get('rec')
      const params = {} as Record<string, unknown>

      if (og) {
        params.og = og
        search.delete('og')
      }
      if (rec) {
        params.rec = rec
        search.delete('rec')
      }
      if (og || rec) {
        promotion = params
        router.replace(`?${search.toString()}`)
      }
    }

    const isDev = process.env.NODE_ENV === 'development'

    if (isDev) {
      return
    }

    tracker.install(
      {
        // logLevel: 1,
        delay: isDev ? 1500 : 15000,
        apiUrl: baseUrl,
      },
      {
        sourceFlag: 'amp',
        eventType: 'official_website_analyst',
        promotion,
      },
    )
    mounted.current = true
    tracker.exposure({ pageType: TrackPageType.Global, sectionName: TrackPageSection }, 'global')
  }, [])
}

export const useTrackClick = (defaultConfig?: TrackerConfig) => {
  const [, mergeConfig] = useTrackerConfig(defaultConfig)
  return (config?: TrackerConfig) => {
    tracker.click(mergeConfig(config))
  }
}

export const useTrackNavigate = (defaultConfig?: TrackerConfig) => {
  const [, mergeConfig] = useTrackerConfig(defaultConfig)
  return (config?: TrackerConfig) => {
    tracker.navigate(mergeConfig(config))
  }
}
